import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
interface City {
  name: string;
  lat: number;
  lng: number;
  size: 'hq' | 'lg' | 'md' | 'sm';
  labelPos: 'top' | 'bottom' | 'left' | 'right';
}
const TAMPA_LAT = 27.9506;
const TAMPA_LNG = -82.4572;
const CITIES: City[] = [
// HQ
{
  name: 'Tampa HQ',
  lat: 27.9506,
  lng: -82.4572,
  size: 'hq',
  labelPos: 'bottom'
},
// Large cities
{
  name: 'St. Petersburg',
  lat: 27.7676,
  lng: -82.6403,
  size: 'lg',
  labelPos: 'bottom'
}, {
  name: 'Clearwater',
  lat: 27.9659,
  lng: -82.8001,
  size: 'lg',
  labelPos: 'left'
}, {
  name: 'Lakeland',
  lat: 28.0395,
  lng: -81.9498,
  size: 'lg',
  labelPos: 'right'
}, {
  name: 'Bradenton',
  lat: 27.4989,
  lng: -82.5748,
  size: 'lg',
  labelPos: 'left'
}, {
  name: 'Sarasota',
  lat: 27.3364,
  lng: -82.5307,
  size: 'lg',
  labelPos: 'bottom'
},
// Medium cities
{
  name: 'Brandon',
  lat: 27.9378,
  lng: -82.2859,
  size: 'md',
  labelPos: 'right'
}, {
  name: 'Riverview',
  lat: 27.8661,
  lng: -82.3265,
  size: 'md',
  labelPos: 'right'
}, {
  name: 'Wesley Chapel',
  lat: 28.1811,
  lng: -82.3526,
  size: 'md',
  labelPos: 'right'
}, {
  name: 'Lutz',
  lat: 28.1511,
  lng: -82.4615,
  size: 'md',
  labelPos: 'left'
}, {
  name: "Land O' Lakes",
  lat: 28.2281,
  lng: -82.4395,
  size: 'md',
  labelPos: 'top'
}, {
  name: 'Plant City',
  lat: 28.0186,
  lng: -82.1229,
  size: 'md',
  labelPos: 'bottom'
}, {
  name: 'Largo',
  lat: 27.9095,
  lng: -82.7873,
  size: 'md',
  labelPos: 'left'
}, {
  name: 'New Port Richey',
  lat: 28.2442,
  lng: -82.7193,
  size: 'md',
  labelPos: 'left'
}, {
  name: 'Spring Hill',
  lat: 28.4769,
  lng: -82.5256,
  size: 'md',
  labelPos: 'top'
}, {
  name: 'Palmetto',
  lat: 27.5214,
  lng: -82.5723,
  size: 'md',
  labelPos: 'right'
},
// Small cities
{
  name: 'Dunedin',
  lat: 28.0197,
  lng: -82.7887,
  size: 'sm',
  labelPos: 'left'
}, {
  name: 'Palm Harbor',
  lat: 28.0778,
  lng: -82.7637,
  size: 'sm',
  labelPos: 'left'
}, {
  name: 'Tarpon Springs',
  lat: 28.1461,
  lng: -82.7568,
  size: 'sm',
  labelPos: 'left'
}, {
  name: 'Temple Terrace',
  lat: 28.0353,
  lng: -82.3893,
  size: 'sm',
  labelPos: 'right'
}, {
  name: 'Valrico',
  lat: 27.9378,
  lng: -82.2365,
  size: 'sm',
  labelPos: 'bottom'
}, {
  name: 'Ruskin',
  lat: 27.7209,
  lng: -82.4332,
  size: 'sm',
  labelPos: 'left'
}, {
  name: 'Sun City Center',
  lat: 27.7181,
  lng: -82.3518,
  size: 'sm',
  labelPos: 'right'
}, {
  name: 'Apollo Beach',
  lat: 27.7731,
  lng: -82.4076,
  size: 'sm',
  labelPos: 'left'
}, {
  name: 'Seffner',
  lat: 27.9836,
  lng: -82.2815,
  size: 'sm',
  labelPos: 'top'
}, {
  name: 'Zephyrhills',
  lat: 28.2336,
  lng: -82.1812,
  size: 'sm',
  labelPos: 'right'
}, {
  name: 'Dade City',
  lat: 28.3647,
  lng: -82.1962,
  size: 'sm',
  labelPos: 'right'
}, {
  name: 'Safety Harbor',
  lat: 27.9909,
  lng: -82.6926,
  size: 'sm',
  labelPos: 'bottom'
}, {
  name: 'Oldsmar',
  lat: 28.0342,
  lng: -82.6651,
  size: 'sm',
  labelPos: 'top'
}, {
  name: 'Seminole',
  lat: 27.8397,
  lng: -82.7901,
  size: 'sm',
  labelPos: 'bottom'
}, {
  name: 'Pinellas Park',
  lat: 27.8428,
  lng: -82.6993,
  size: 'sm',
  labelPos: 'right'
}, {
  name: 'Bartow',
  lat: 27.8964,
  lng: -81.8431,
  size: 'sm',
  labelPos: 'right'
}, {
  name: 'Gibsonton',
  lat: 27.8336,
  lng: -82.3815,
  size: 'sm',
  labelPos: 'left'
}, {
  name: 'Wimauma',
  lat: 27.7125,
  lng: -82.3012,
  size: 'sm',
  labelPos: 'right'
}, {
  name: 'Lithia',
  lat: 27.8667,
  lng: -82.2167,
  size: 'sm',
  labelPos: 'bottom'
}, {
  name: 'Dover',
  lat: 27.9942,
  lng: -82.2187,
  size: 'sm',
  labelPos: 'top'
}, {
  name: 'Odessa',
  lat: 28.1839,
  lng: -82.5934,
  size: 'sm',
  labelPos: 'top'
}, {
  name: 'Citrus Park',
  lat: 28.0781,
  lng: -82.5726,
  size: 'sm',
  labelPos: 'left'
}, {
  name: 'Carrollwood',
  lat: 28.0503,
  lng: -82.5065,
  size: 'sm',
  labelPos: 'top'
}, {
  name: 'Town N Country',
  lat: 28.0106,
  lng: -82.5773,
  size: 'sm',
  labelPos: 'bottom'
}, {
  name: 'Ellenton',
  lat: 27.5217,
  lng: -82.5276,
  size: 'sm',
  labelPos: 'left'
}, {
  name: 'Parrish',
  lat: 27.5842,
  lng: -82.3562,
  size: 'sm',
  labelPos: 'right'
}, {
  name: 'Hudson',
  lat: 28.3644,
  lng: -82.6932,
  size: 'sm',
  labelPos: 'left'
}, {
  name: 'Port Richey',
  lat: 28.2717,
  lng: -82.7196,
  size: 'sm',
  labelPos: 'bottom'
}];
// Map dimensions & scaling — circle fills the entire viewBox
const RADIUS_PX = 480;
const PADDING = 40;
const MAP_WIDTH = (RADIUS_PX + PADDING) * 2;
const MAP_HEIGHT = (RADIUS_PX + PADDING) * 2;
const CENTER_X = MAP_WIDTH / 2;
const CENTER_Y = MAP_HEIGHT / 2;
// Scale so that 50 miles ≈ RADIUS_PX in SVG units
// Tampa 50-mile radius spans ~1.45° lng and ~0.72° lat
const SCALE_X = RADIUS_PX / 1.0;
const SCALE_Y = RADIUS_PX / 0.92;
function toSvgCoords(lat: number, lng: number): {
  x: number;
  y: number;
} {
  const x = CENTER_X + (lng - TAMPA_LNG) * SCALE_X;
  const y = CENTER_Y - (lat - TAMPA_LAT) * SCALE_Y;
  return {
    x,
    y
  };
}
export function CoverageMap() {
  const {
    t
  } = useLanguage();
  return <section id="coverage" className="py-24 bg-brand-black border-y border-white/5" data-id="element-93">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-95">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold text-brand-red mb-4 uppercase tracking-wide" data-id="element-96">
            {t.coverage.title}
          </h2>
          <h3 className="text-2xl text-white font-medium mb-4" data-id="element-97">
            {t.coverage.subtitle}
          </h3>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-98">
            {t.coverage.description}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative w-full rounded-2xl overflow-hidden border-2 border-brand-red/30 shadow-[0_0_40px_rgba(220,38,38,0.15)] bg-[#0A0A0A]" data-id="element-99">
          {/* Legend */}
          <div className="absolute top-6 left-6 z-20 bg-brand-black/95 backdrop-blur-md border border-white/10 px-5 py-4 rounded-xl shadow-xl" data-id="element-100">
            <div className="flex items-center gap-3 mb-3" data-id="element-101">
              <div className="w-3 h-3 rounded-full bg-brand-red animate-pulse shadow-[0_0_10px_rgba(220,38,38,0.8)]" data-id="element-102"></div>
              <span className="text-white font-oswald tracking-wide text-sm" data-id="element-103">
                {t.coverage.radius}
              </span>
            </div>
            <div className="flex items-center gap-3 mb-3" data-id="element-104">
              <div className="w-3 h-3 rounded-full bg-brand-yellow shadow-[0_0_10px_rgba(250,204,21,0.8)]" data-id="element-105"></div>
              <span className="text-gray-300 font-oswald tracking-wide text-sm" data-id="element-106">
                TAMPA HQ
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-107">
              <div className="w-3 h-3 rounded-full bg-white" data-id="element-108"></div>
              <span className="text-gray-400 font-oswald tracking-wide text-sm" data-id="element-109">
                MAJOR CITIES
              </span>
            </div>
          </div>

          {/* SVG Map */}
          <div className="w-full" style={{
          aspectRatio: '1 / 1'
        }} data-id="element-110">
            <svg viewBox={`0 0 ${MAP_WIDTH} ${MAP_HEIGHT}`} width="100%" height="100%" preserveAspectRatio="xMidYMid meet" data-id="element-111">
              <defs data-id="element-112">
                <radialGradient id="coverageGlow" cx="50%" cy="50%" r="50%" data-id="element-113">
                  <stop offset="0%" stopColor="#DC2626" stopOpacity="0.15" data-id="element-114" />
                  <stop offset="60%" stopColor="#DC2626" stopOpacity="0.08" data-id="element-115" />
                  <stop offset="100%" stopColor="#DC2626" stopOpacity="0" data-id="element-116" />
                </radialGradient>
                <pattern id="dots" width="30" height="30" patternUnits="userSpaceOnUse" data-id="element-117">
                  <circle cx="2" cy="2" r="1.5" fill="rgba(255,255,255,0.05)" data-id="element-118" />
                </pattern>
              </defs>

              {/* Background dots */}
              <rect width={MAP_WIDTH} height={MAP_HEIGHT} fill="url(#dots)" data-id="element-119" />

              {/* Coverage circle glow */}
              <circle cx={CENTER_X} cy={CENTER_Y} r={RADIUS_PX + 30} fill="url(#coverageGlow)" data-id="element-120" />

              {/* Distance Rings */}
              {[{
              ratio: 0.3,
              label: '~15 MI'
            }, {
              ratio: 0.6,
              label: '~30 MI'
            }, {
              ratio: 1.0,
              label: '50 MI MAX RADIUS'
            }].map((ring, i) => {
              const r = RADIUS_PX * ring.ratio;
              const isOuter = i === 2;
              return <g key={`ring-${i}`} data-id="element-121">
                    <circle cx={CENTER_X} cy={CENTER_Y} r={r} fill={isOuter ? 'rgba(220, 38, 38, 0.03)' : 'none'} stroke={isOuter ? '#DC2626' : 'rgba(255,255,255,0.1)'} strokeWidth={isOuter ? '2.5' : '1'} strokeDasharray={isOuter ? '10 7' : '4 8'} opacity={isOuter ? '0.7' : '1'} data-id="element-122" />
                    <text x={CENTER_X} y={CENTER_Y - r - 10} textAnchor="middle" fill={isOuter ? '#DC2626' : 'rgba(255,255,255,0.3)'} fontSize={isOuter ? '20' : '16'} fontWeight="bold" fontFamily="'Oswald', sans-serif" letterSpacing="1.5" paintOrder="stroke fill" stroke="#0A0A0A" strokeWidth="4" strokeLinejoin="round" data-id="element-123">
                      {ring.label}
                    </text>
                  </g>;
            })}

              {/* City dots and labels */}
              {CITIES.map((city, idx) => {
              const pos = toSvgCoords(city.lat, city.lng);
              const isTampa = city.size === 'hq';
              const isLarge = city.size === 'lg';
              const isMedium = city.size === 'md';
              const dotRadius = isTampa ? 14 : isLarge ? 10 : isMedium ? 7 : 5;
              const fontSize = isTampa ? 32 : isLarge ? 26 : isMedium ? 20 : 17;
              const dotColor = isTampa ? '#FACC15' : isLarge ? '#FFFFFF' : '#DC2626';
              const textColor = isTampa ? '#FACC15' : isLarge ? '#FFFFFF' : isMedium ? '#E5E7EB' : '#9CA3AF';
              let textX = pos.x;
              let textY = pos.y;
              let textAnchor = 'middle';
              switch (city.labelPos) {
                case 'top':
                  textY = pos.y - dotRadius - 10;
                  break;
                case 'bottom':
                  textY = pos.y + dotRadius + 20 + (isTampa ? 4 : 0);
                  break;
                case 'left':
                  textX = pos.x - dotRadius - 10;
                  textY = pos.y + fontSize / 3;
                  textAnchor = 'end';
                  break;
                case 'right':
                  textX = pos.x + dotRadius + 10;
                  textY = pos.y + fontSize / 3;
                  textAnchor = 'start';
                  break;
              }
              return <g key={idx} data-id="element-124">
                    {/* Tampa HQ Pulse */}
                    {isTampa && <>
                        <circle cx={pos.x} cy={pos.y} r="18" fill="none" stroke="#FACC15" strokeWidth="2" opacity="0.4" data-id="element-125">
                          <animate attributeName="r" values="18;40;18" dur="2s" repeatCount="indefinite" data-id="element-126" />
                          <animate attributeName="opacity" values="0.5;0;0.5" dur="2s" repeatCount="indefinite" data-id="element-127" />
                        </circle>
                        <circle cx={pos.x} cy={pos.y} r="28" fill="none" stroke="#FACC15" strokeWidth="1" opacity="0.2" data-id="element-128">
                          <animate attributeName="r" values="28;50;28" dur="2.5s" repeatCount="indefinite" data-id="element-129" />
                          <animate attributeName="opacity" values="0.3;0;0.3" dur="2.5s" repeatCount="indefinite" data-id="element-130" />
                        </circle>
                      </>}

                    {/* City dot */}
                    <circle cx={pos.x} cy={pos.y} r={dotRadius} fill={dotColor} stroke="#0A0A0A" strokeWidth="2" data-id="element-131" />

                    {/* City name label */}
                    <text x={textX} y={textY} textAnchor={textAnchor} fill={textColor} fontSize={fontSize} fontWeight={isTampa || isLarge ? 'bold' : '600'} fontFamily="'Oswald', sans-serif" letterSpacing="0.5" paintOrder="stroke fill" stroke="#0A0A0A" strokeWidth={isTampa ? '6' : '5'} strokeLinejoin="round" style={{
                  textTransform: 'uppercase'
                }} data-id="element-132">
                      {city.name}
                    </text>
                  </g>;
            })}
            </svg>
          </div>
        </motion.div>
      </div>
    </section>;
}